import {createStyles, makeStyles, Theme} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            padding: '25px 0',
        },
        buttonRow: {
            justifyContent: 'flex-end',
            display: 'flex',
            gap: 8
        },
        button: {
            width: '50%'
        },
        addButton: {
            width: 200,
        },
        [theme.breakpoints.down('sm')]: {
            buttonRow: {
                justifyContent: 'flex-end',
                display: 'flex',
                flexDirection: 'column'
            },
            button: {
                width: '100%'
            },
            addButton: {
                width: '100%',
            }
        }
    }),
);

export default useStyles;
